import * as services from "./services";

export async function getTaxesAction({ commit }, { userId, page, pageSize }) {
  commit("SET_PROCESSING", true);
  try {
    const { data } = await services.getByDriver(userId, page, pageSize);
    commit("SET_TAXES", data.items);
    commit("SET_PAGE", data.page);
    commit("SET_PAGE_SIZE", data.pageSize);
    commit("SET_TOTAL_ITEMS", data.totalItems);
    commit("SET_TOTAL_PAGES", data.totalPages);
    return { success: true, data };
  } catch (e) {
    commit("SET_TAXES", []);
    return { success: false, message: e.message };
  } finally {
    commit("SET_PROCESSING", false);
  }
}

export async function getShowTaxesAction({ commit }, userId) {
  try {
    const { data } = await services.getShowTaxes(userId);
    commit("SET_SHOW_TAXES", data.totalItems > 0);
  } catch {
    commit("SET_SHOW_TAXES", false);
  }
}

export async function importTaxesAction({ commit }, file) {
  commit("SET_PROCESSING", true);
  try {
    const { data } = await services.importTaxes(file);
    commit("SET_IMPORT_RESULT", data);
    return { success: true, data };
  } catch (e) {
    return { success: false, message: e?.toString() || "Błąd importu" };
  } finally {
    commit("SET_PROCESSING", false);
  }
}

export async function downloadTemplateAction() {
  try {
    const response = await services.getTemplate();
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "szablon_podatki.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (e) {
    return { success: false, message: e.message };
  }
}
